// extracted by mini-css-extract-plugin
module.exports = {"RoundPlusButton":"style_RoundPlusButton__1_Jhg","circle":"style_circle__1LIwT","text":"style_text__WppOZ"};